import React from "react";

/**
 * MobileBoxRow — wraps a group of cards so they render as:
 *   • On mobile (< md): a horizontal snap-scroll carousel showing ONE item at a
 *     time (w-full, snap-center). The user swipes to see the next box.
 *   • On md+ screens: the standard grid the designer wants (via `cols` prop).
 *
 * Usage:
 *   <MobileBoxRow cols="md:grid-cols-4" gap="gap-5" className="mt-10">
 *     <div className="rounded-2xl ..."/>
 *     <div className="rounded-2xl ..."/>
 *     ...
 *   </MobileBoxRow>
 */
export const MobileBoxRow = ({
  children,
  cols = "md:grid-cols-3",
  gap = "gap-5",
  className = "",
}) => {
  const base =
    "flex min-w-0 max-w-full snap-x snap-mandatory overflow-x-auto scroll-px-4 pb-4 -mx-4 px-4 md:mx-0 md:px-0 md:pb-0 md:grid md:overflow-visible";
  return (
    <div className={`${base} ${gap} ${cols} ${className}`}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        const existing = child.props.className || "";
        return React.cloneElement(child, {
          className: `snap-center shrink-0 w-[calc(100vw-2rem)] max-w-full md:w-auto md:max-w-none ${existing}`,
        });
      })}
    </div>
  );
};

export default MobileBoxRow;
